import script from "./Test3.vue?vue&type=script&setup=true&lang=js"
export * from "./Test3.vue?vue&type=script&setup=true&lang=js"

import "./Test3.vue?vue&type=style&index=0&id=48fe4aeb&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48fe4aeb"]])

export default __exports__